/*
 *    Copyright [2007-2025] [wisemapping]
 *
 *   Licensed under WiseMapping Public License, Version 1.0 (the "License").
 *   It is basically the Apache License, Version 2.0 (the "License") plus the
 *   "powered by wisemapping" text requirement on every single page;
 *   you may not use this file except in compliance with the License.
 *   You may obtain a copy of the license at
 *
 *       https://github.com/wisemapping/wisemapping-open-source/blob/main/LICENSE.md
 *
 *   Unless required by applicable law or agreed to in writing, software
 *   distributed under the License is distributed on an "AS IS" BASIS,
 *   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *   See the License for the specific language governing permissions and
 *   limitations under the License.
 */
import PositionType from '../../PositionType';
import ElementPeer from './ElementPeer';

class ElipsePeer extends ElementPeer {
  private _position: PositionType;

  constructor() {
    const svgElement = window.document.createElementNS('http://www.w3.org/2000/svg', 'ellipse');
    super(svgElement);

    this.attachChangeEventListener('strokeStyle', ElementPeer.prototype.updateStrokeStyle);
    this._position = { x: 0, y: 0 };
  }

  setSize(width: number, height: number) {
    super.setSize(width, height);
    this._native.setAttribute('rx', (width / 2).toFixed(0));
    this._native.setAttribute('ry', (height / 2).toFixed(0));
  }

  setPosition(pcx: number, pcy: number) {
    this._position = { x: pcx, y: pcy };

    this._native.setAttribute('cx', pcx.toFixed(0));
    this._native.setAttribute('cy', pcy.toFixed(0));
  }

  getPosition() {
    return this._position;
  }
}

export default ElipsePeer;
